import Rest from '../../Rest'

export default class ReportingChannelDeadlineConfigService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/reporting_channel_handling/deadline_config'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  grid(path: string = '', data: any) {
    if (path !== '') {
      return this.get(path, data)
    }
    return this.get('grid', data)
  }

  read(id: Number) {
    return this.get(`/${id}`)
  }

  create(data: any, params: any = {}) {
    // Se houver workflow_config_id nos params, adiciona ao body
    if (params.workflow_config_id) {
      data.workflow_config_id = params.workflow_config_id
    }
    return this.post('', data)
  }

  update(data: any, params: any = {}) {
    // Se houver workflow_config_id nos params, adiciona ao body
    if (params.workflow_config_id) {
      data.workflow_config_id = params.workflow_config_id
    }
    return this.put(`/${data.id}`, data)
  }

  destroy(id: Number) {
    return this.delete(`/${id}`)
  }
}

